import { create } from 'zustand';
import axios from 'axios';
import config from '../config/config';

interface AppState {
  isRestricted: boolean;
  fetchIsRestricted: (address: string) => Promise<void>;
}

const useAppStore = create<AppState>((set, get) => ({
  isRestricted: false,

  fetchIsRestricted: async (address: string) => {
    const response = await axios.post<{ walletAddress: string }, { status: number }>(
      `${config.get('ipKyc.baseUrl')}/detect-and-check-ip`,
      { walletAddress: address }
    );
    set({ isRestricted: response.status === 401 });
  },
}));

export default useAppStore;
